<template>
  <div class="popup_in">
    <div class="popup">
      <div class="popup_close popup_close-25 close-animate">
        <a href="javascript:void(0);" @click="$emit('close')"><CloseBlue /></a>
      </div>
      <div v-show="step === 0" class="popup-content">
        <div class="title--32 tx--blue2">
          הוספת מסמכים
        </div>
        <div class="title--18" style="margin-bottom: 20px;">
          ניתן להוסיף מסמך בסיומת pdf, jpg, png
        </div>
        <div class="select2-doc-type" :class="{ disabled: chosenType }">
          <select2 v-model="type" :disabled="chosenType ? true : false">
            <option value="">בחר את סוג המסמכים המצורפים</option>
            <option
              v-for="option in docTypes"
              :key="option.value"
              :value="option.value"
            >
              {{ option.title }}
            </option>
          </select2>
        </div>
        <div
          class="flex flex--start inner_group step-4-docs-group"
          style="background-color: #e1e1dd;"
        >
          <a
            class="file_item relative flex desk-block"
            v-for="(file, index) in files"
            :key="index"
          >
            <span @click.prevent="removeFile(index)" class="file-remove">
              <CloseSvg />
            </span>
            <img class="no_mobile" src="/assets/img/svg/ic-file.svg" />
            <span class="tx_file block">{{ file.name }}</span>
          </a>
          <div class="bt_upload relative flex desk-block">
            <input
              id="file"
              type="file"
              ref="files"
              multiple
              @change="handleFilesUpload"
            />
            <div class="ic-upload ease">
              <UploadSvg />
            </div>
            <div class="tx_file ease">הוספת מסמך</div>
          </div>
        </div>
        <span class="error-message" v-show="errMsg">{{ errMsg }}</span>

        <div class="pop-delete-block-btns flex">
          <a
            class="bt_blue bt_border m-100"
            @click="$emit('close')"
            href="javascript:void(0);"
          >
            ביטול
          </a>
          <a
            class="bt_blue bt-approveDelete m-100"
            @click="uploadFiles"
            href="javascript:void(0)"
          >
            אישור
            <vue-loaders-ball-clip-rotate
              v-show="isLoading"
              color="white"
              scale="1.2"
              style="position: relative;top: 9px;"
            ></vue-loaders-ball-clip-rotate>
          </a>
        </div>
      </div>

      <div v-show="step === 1" class="popup-content">
        <div class="title--32 tx--blue2">
          הוספת מסמכים
        </div>
        <div class="title--18">
          המסמך צורף בהצלחה. <br />
          האם להוסיף מסמך נוסף?
        </div>
        <div class="pop-delete-block-btns flex">
          <a
            class="bt_blue bt_border m-100"
            @click="step = 0"
            href="javascript:void(0);"
          >
            כן
          </a>
          <a
            class="bt_blue bt_border m-100"
            @click="$emit('close')"
            href="javascript:void(0);"
          >
            לא
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseBlue from "../../assets/img/svg/close-blue.svg";
import UploadSvg from "../../assets/img/svg/upload.svg";
import CloseSvg from "../../assets/img/svg/close.svg";
import { uploadDocuments } from "../../utilities/globals";

export default {
  name: "AddDocuments",
  components: { CloseBlue, UploadSvg, CloseSvg },
  props: ["directUpload", "chosenType"],
  data() {
    return {
      isLoading: false,
      step: 0,
      files: [],
      type: "",
      docTypes: [
        {
          title: "דוח רפואי",
          value: "medical-report"
        },
        {
          title: "הפנייה קלינית של רופא",
          value: "reference-document"
        },
        {
          title: "טופס התחייבות כלפי HMC",
          value: "hmc-obligations"
        },
        {
          title: "טופס הגשת תביעת בריאות לחברת ביטוח",
          value: "insurance-claim-request-form"
        },
        {
          title: `מסמכים רפואיים שהובאו ע"י מטופל`,
          value: "medicaldocuments-patient"
        },
        {
          title: `פענוח בדיקות הדמייה`,
          value: "ext-imaging-diagnosis"
        },
        {
          title: `הסכמה מדעת לפעולה`,
          value: "clinic-confirm-agreement"
        },
        {
          title: "תוצאות בדיקה",
          value: "results"
        }
      ],
      errMsg: ""
    };
  },
  methods: {
    uploadDocuments,
    handleFilesUpload() {
      const elFiles = this.$refs.files.files;
      for (const filesKey in elFiles) {
        if (elFiles[filesKey] instanceof File) {
          this.files.push(elFiles[filesKey]);
        }
      }
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    async uploadFiles() {
      if (this.isLoading) return;
      this.errMsg = "";
      if (!this.type) {
        this.errMsg = "נא לבחור סוג מסמך מצורף";
        return;
      }
      if (!this.files.length) {
        this.errMsg = "נא לצרף מסמך";
        return;
      }
      this.isLoading = true;

      if (this.directUpload) {
        await this.uploadDocuments(
          this.files,
          this.directUpload.id,
          this.type,
          this.directUpload.type === "surgery"
        );

        if (this.directUpload.type === "surgery") {
          this.$root.$emit("getSurgeryInfo");
        }
        this.isLoading = false;
        this.files = [];
        this.type = "";
        this.errMsg = "";
        this.step = 1;
        return;
      } else if (
        this.$route.name == "surg-edit" ||
        this.$route.name == "surg-add-info"
      ) {
        this.$root.$emit("uploadSurgFiles", {
          files: this.files,
          type: this.type
        });
      } else {
        await this.uploadDocuments(
          this.files,
          this.$route.params.id,
          this.type
        );
        this.$root.$emit("getAppointmentInfo");
      }
      this.$emit("close");
      this.isLoading = false;
    }
  },
  mounted() {
    this.type = this.chosenType || "";
  }
};
</script>
